import client from 'api/client';

export function getCountries() {
    return client.get('/select_options/country');
}

export function getNationalities() {
    return client.get('/select_options/nationality');
}

export function getRegions() {
    return client.get('/select_options_regions');
}

export function getRelations() {
    return client.get('/select_options/relation');
}

export function getRelationsChild() {
    return client.get('/select_options/relation_child');
}

export function getRelationsNonChild() {
    return client.get('/select_options/relation_non_child');
}

export function getEducationLevels() {
    return client.get('/select_options/education');
}

export function getExpertiseList() {
    return client.get('/expertise_list');
}

export function getWorkPermits() {
    return client.get('/select_options/work_permit');
}

export function getFieldOfStudyOptions() {
    return client.get('/select_options/field_of_study');
}

export function getNominationOptions() {
    return client.get('/select_options/nomination');
}

export function getBusinessSectors() {
    return client.get('/select_options/business_sector');
}

export function getResidentialStatus(country: string) {
    return client.get(`/residential_status/${country}`);
}

export function getProfessions(country: string) {
    return client.get(`/professions/${country}`);
}

export function getRegionOccupations() {
    return client.get('/select_options?category=occupation');
}
